export default {
  title: 'Resumen de empresa',
  description: '¡Bienvenido de nuevo, {{name}}! Esto es lo que ocurre con tu marketing.',
};
